import { useQuery } from '@apollo/client';

import { useApplicationContext } from '../../core/contexts/ApplicationContext.tsx';
import { canUseChat } from '../../users/utils.ts';
import { GET_CHAT_AGENTS } from '../queries.ts';

// Users without an enabled inbox agent run their email automations as themselves. `loading` is true until
// that's known, so callers can avoid flashing the wrong UI for customers who turn out to have agents.
export const useHasNoEnabledAgent = () => {
    const { user } = useApplicationContext();
    const chatEnabled = canUseChat(user);
    const { data } = useQuery(GET_CHAT_AGENTS, { skip: !chatEnabled });

    const loading = chatEnabled && !data;
    const hasNoEnabledAgent = chatEnabled && Boolean(data) && data.agents.filter((agent) => agent.enabled).length === 0;
    return { hasNoEnabledAgent, loading };
};
